import script from "./DocumentoEntradaItensSmartMode.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoEntradaItensSmartMode.vue?vue&type=script&setup=true&lang=js"

import "./DocumentoEntradaItensSmartMode.vue?vue&type=style&index=0&id=46513ef6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46513ef6"]])

export default __exports__